import React from 'react';
import BaseClass from '@/pages/BaseClass';
import {
	HashRouter,
	BrowserRouter as Router,
	Route,
	IndexRoute,
	Switch,
} from 'react-router-dom';

import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';
import Profile from './user/Profile';
import Address from './user/Address';
import Account from './user/Account';
import Order from './user/Order';
import GoodsOrder from './user/GoodsOrder';
import Charge from './user/Charge';
import ChargeEvent from './user/ChargeEvent';
import ChangePassword from './user/ChangePassword';
import Rank from './user/Rank';
import Log from './user/Log';
import Success from './user/Success';
import Rights from './user/Rights';
import OrderService from './user/OrderService';
import OrderServiceAdd from './user/OrderServiceAdd';
import Feedback from './user/Feedback';
import Coupon from './user/Coupon';
import PointsShop from './user/PointsShop';
import PointsGoods from './user/PointsGoods';
import Refund from './user/Refund';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'navIndex':0,
			'userInfo':{},
		};
	}
	
	componentDidMount()
	{
		let userInfo = CommonValue.get('user_info');
		//隐藏手机号
		if(userInfo['user_name'])
			userInfo['user_name'] = userInfo['user_name'].replace(userInfo['user_name'].substr(3,4),'****');
		this.setState({
			'userInfo':userInfo,
		});
		
		this.initNavIndex(this.props.location.pathname);
		this.props.history.listen((e)=>{
			this.initNavIndex(e.pathname);
		});
	}
	
	initNavIndex(pathname)
	{
		let navIndex = -1;
		switch(pathname)
		{
			case '/user':
					
			case '/user/profile':
				navIndex = 0;
				break;
			case '/user/address':
				navIndex = 1;
				break;
			case '/user/account':
				navIndex = 2;
				break;
			case '/user/pointsShop':
				navIndex = 3;
				break;
			case '/user/feedback':
				navIndex = 4;
				break;
			case '/user/order':
				navIndex = 5;
				break;
			case '/user/refund':
				navIndex = 14;
				break;
			case '/user/orderService':
			case '/user/orderServiceAdd':
				navIndex = 6;
				break;
			case '/user/charge':
				navIndex = 7;
				break;
			case '/user/chargeEvent':
				navIndex = 8;
				break;
			case '/user/coupon':
				navIndex = 9;
				break;
			case '/user/rights':
				navIndex = 10;
				break;
			case '/user/rank':
				navIndex = 11;
				break;
			case '/user/log':
				navIndex = 12;
				break;
			case '/user/changePassword':
				navIndex = 13;
				break;
			
			default:
				if(pathname.indexOf('/user/pointsGoods') === 0)
					navIndex = 3;
				break;
		}
		this.setState({
			'navIndex':navIndex,
		});
	}
	
	render()
	{
		return (
			<div className="bg-white">
				<div className="height-40"></div>
				<div className="body user-container">
					<div className="user-left">
						<div className="user-left-inner">
							<div className="user-nav">
								<dl>
									<dt>
										<span className="clips user-nav-ico-1"></span>
										个人中心
									</dt>
									<dd> <a href={ngUrl('user','profile')} className={this.state.navIndex == 0 ? 'now':''}> 企业资料 </a> </dd>
									<dd> <a href={ngUrl('user','address')} className={this.state.navIndex == 1 ? 'now':''}> 地址管理 </a> </dd>
									{+this.state.userInfo['is_manager'] ? (
										<dd> <a href={ngUrl('user','account')} className={this.state.navIndex == 2 ? 'now':''}> 员工账号 </a> </dd>
									):''}
									<dd> <a href={ngUrl('user','pointsShop')} className={this.state.navIndex == 3 ? 'now':''}> 积分商城 </a> </dd>
									<dd> <a href={ngUrl('user','feedback')} className={this.state.navIndex == 4 ? 'now':''}> 投诉建议 </a> </dd>
								</dl>
								<dl>
									<dt>
										<span className="clips user-nav-ico-2"></span>
										订单中心
									</dt>
									<dd> <a href={ngUrl('user','order')} className={this.state.navIndex == 5 ? 'now':''}> 我的订单 </a> </dd>
									<dd> <a href={ngUrl('user','refund')} className={this.state.navIndex == 14 ? 'now':''}> 退款记录 </a> </dd>
									<dd> <a href={ngUrl('user','orderService')} className={this.state.navIndex == 6 ? 'now':''}> 售后记录 </a> </dd>
								</dl>
								<dl>
									<dt>
										<span className="clips user-nav-ico-3"></span>
										资产中心
									</dt>
									{+this.state.userInfo['is_manager'] ? (
									<dd> <a href={ngUrl('user','charge')} className={this.state.navIndex == 7 ? 'now':''}> 账户充值 </a> </dd>
									):''}
									{+this.state.userInfo['is_manager'] ? (
									<dd> <a href={ngUrl('user','chargeEvent')} className={this.state.navIndex == 8 ? 'now':''}> 活动充值 </a> </dd>
									):''}
									<dd> <a href={ngUrl('user','coupon')} className={this.state.navIndex == 9 ? 'now':''}> 我的优惠券 </a> </dd>
								</dl>
								<dl>
									<dt>
										<span className="clips user-nav-ico-4"></span>
										账户中心
									</dt>
									<dd> <a href={ngUrl('user','rights')} className={this.state.navIndex == 10 ? 'now':''}> 会员权益 </a> </dd>
									{+this.state.userInfo['is_manager'] && +this.state.userInfo['rank_show'] ? (
									<dd> <a href={ngUrl('user','rank')} className={this.state.navIndex == 11 ? 'now':''}> 购买会员 </a> </dd>
									):''}
									{+this.state.userInfo['is_manager'] ? (
									<dd> <a href={ngUrl('user','log')} className={this.state.navIndex == 12 ? 'now':''}> 购买记录 </a> </dd>
									):''}
									<dd> <a href={ngUrl('user','changePassword')} className={this.state.navIndex == 13 ? 'now':''}> 修改资料 </a> </dd>
								</dl>
							</div>
						</div>
					</div>
					<div className="user-right">
						<Switch>
							<Route exact path="/" component={Profile} />
							<Route exact path="/user" component={Profile} />
							<Route path="/user/profile" component={Profile} />
							<Route path="/user/address" component={Address} />
							<Route path="/user/account" component={Account} />
							<Route path="/user/order" component={Order} />
							<Route path="/user/goodsOrder" component={GoodsOrder} />
							<Route path="/user/charge" component={Charge} />
							<Route path="/user/chargeEvent" component={ChargeEvent} />
							<Route path="/user/changePassword" component={ChangePassword} />
							<Route path="/user/log" component={Log} />
							<Route path="/user/rank" component={Rank} />
							<Route path="/user/success" component={Success} />
							<Route path="/user/rights" component={Rights} />
							<Route path="/user/orderService" component={OrderService} />
							<Route path="/user/orderServiceAdd" component={OrderServiceAdd} />
							<Route path="/user/feedback" component={Feedback} />
							<Route path="/user/coupon" component={Coupon} />
							<Route path="/user/pointsShop" component={PointsShop} />
							<Route path="/user/pointsGoods/:id" component={PointsGoods} />
							<Route path="/user/refund" component={Refund} />
						</Switch>
					</div>
					<div className="clear"></div>
				</div>
				<div className="height-40"></div>
			</div>
		);
	}
}

